import { createContext, useContext, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [projectId, setProjectId] = useState("all");

  const { data: projects = [] } = useQuery({
    queryKey: ["projects"],
    queryFn: async () => (await api.get("/projects")).data,
  });

  const projectParam = projectId && projectId !== "all" ? { project_id: projectId } : {};

  return (
    <ProjectContext.Provider value={{ projects, projectId, setProjectId, projectParam }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProjects = () => useContext(ProjectContext);
